export default "__VITE_ASSET__D7Qa34NE__"